import { css } from '@emotion/react';

export default $ => css`
  .icon-check-field {
    border: 1px solid black;
    width: 26px;
    padding: 0px 6px;
    margin: 5px 6px 5px 3px;
    height: 26px;

    &.no-box {
      border-width: 0;
    }

    &.btn-success {
      background-color: transparent;
      color: ${$.successMain};
      border-color: ${$.successMain};
    }

    &.btn-danger {
      background-color: transparent;
      color: ${$.dangerMain};
      border-color: ${$.dangerMain};
    }
  }

  td > .form-group.field > .form-group-icon-check-field {
    text-align: center;
  }
`;
